var r = { exports: {} };
export {
  r
};
//# sourceMappingURL=index2.js.map
